import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import atImage from '../../../../images/pages/homepage/at.svg';
import styles from './Instagram.module.sass';
import './SlickOverrides.sass';
import Button from '../../../ui_kit/button/Button';
import SliderArrows from '../../../ui_kit/slider_arrows/SliderArrows';
import InstagramImage from './instagram_image/InstagramImage';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const INSTAGRAM_RECENT_POSTS_URL = 'https://graph.instagram.com/me/media?limit=20&fields=id,media_type,media_url,permalink,thumbnail_url,caption&access_token=';

class Instagram extends Component {
  constructor(props) {
    super(props);
    this.state = {
      instagramData: [],
      hidePrevArrow: true,
      hideNextArrow: false,
    };
  }

  componentDidMount() {
    const { token } = this.props;

    fetch(INSTAGRAM_RECENT_POSTS_URL + token).then((result) => result.json())
      .then((result) => {
        if (result.error) {
          return;
        }
        this.setState({ instagramData: result.data });
      });
  }

  onPrevClick = () => {
    this.slider.slickPrev();
  };

  onNextClick = () => {
    this.slider.slickNext();
  };

  render() {
    const { instagramData, hidePrevArrow, hideNextArrow } = this.state;
    return (
      <div className={styles.instagram}>
        <div className={styles.content}>
          <div className={styles.title}>
            Our Community
          </div>
          <div className={styles['title-block']}>
            <div className={styles['desktop-title']}>
              Check out @volitionbeauty on Instagram
            </div>
            <Button
              text="FOLLOW US"
              color="blue"
              size="small"
              className={styles['follow-button']}
              href="https://instagram.com/volitionbeauty"
              target="_blank"
            />
          </div>
          <div className={styles.content}>
            <div className={styles['mobile-only']}>
              <a href="https://instagram.com/volitionbeauty" rel="nofollow noreferrer" target="_blank">
                <div className={styles['volition-account']}>
                  <div className={styles.image}>
                    <img className="lazyload" data-src={atImage} alt="at" />
                  </div>
                  <div className={styles.title}>
                    volitionbeauty
                  </div>
                </div>
              </a>
              <div className={styles.feed}>
                {instagramData.map((image) => (
                  <InstagramImage
                    image={image}
                    key={image.id}
                  />
                ))}
              </div>
            </div>
            <div className={`instagram-slider ${styles['desktop-only']}`}>
              <div className={styles.feed}>
                <Slider
                  ref={(slider) => {
                    this.slider = slider;
                  }}
                  dots={false}
                  infinite={false}
                  arrows={false}
                  speed={500}
                  slidesToShow={5}
                  slidesToScroll={5}
                  beforeChange={(_oldIndex, newIndex) => {
                    this.setState({
                      hidePrevArrow: newIndex === 0,
                      hideNextArrow: newIndex === 15,
                    });
                  }}
                >
                  {instagramData.map((image) => (
                    <InstagramImage
                      image={image}
                      key={image.id}
                    />
                  ))}
                </Slider>
              </div>
            </div>
          </div>
          { instagramData.length > 0 && (
            <SliderArrows
              onNextClick={this.onNextClick}
              onPrevClick={this.onPrevClick}
              hidePrevArrow={hidePrevArrow}
              hideNextArrow={hideNextArrow}
            />
          )}
          <div className={styles.tag}>
            tag #volitionbeauty to be featured
          </div>
        </div>
      </div>
    );
  }
}

Instagram.propTypes = {
  token: PropTypes.string.isRequired,
};

export default Instagram;
